module.exports = __webpack_public_path__ + "static/media/route-highway.c22f6532.svg";